import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import JobTitle from '../../components/JobTitle'
import JobDetails from '../../components/JobDetails'
import JobFunctions from '../../components/JobFunctions'
import { BackTop } from 'antd'
import { InstallJobMenu } from '../../components/InstallJobMenu'
import { RepairJobMenu } from '../../components/RepairJobMenu'

const propTypes = {}

class JobView extends Component {
  constructor(props) {
    super(props)

    this.state = {
      current: this.props.match.params.shortcutPage
        ? this.props.match.params.shortcutPage
        : 'Job Attachments',
      shortcutItemId: this.props.match.params.shortcutId
        ? this.props.match.params.shortcutId
        : null,
      detailShowing: true,
      scheduleApplicationId: 0,
      scheduleApplicationType: 'requested_bec',
      screenWidth: 0,
      screenHeigth: 0,
      isEditing: false
    }
  }

  updateDimensions = () => {
    const w = window
    const d = document
    const documentElement = d.documentElement
    const body = d.getElementsByTagName('body')[0]
    const width = w.innerWidth || documentElement.clientWidth || body.clientWidth
    const height = w.innerHeight || documentElement.clientHeight || body.clientHeight
    this.setState({
      screenWidth: width,
      screenHeigth: height
    })
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener('resize', this.updateDimensions)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  navTo = (id, type) => {
    this.setState({
      current: 'Schedule Applications/Permits',
      scheduleApplicationId: id,
      scheduleApplicationType: type
    })
  }

  handleShortcut = (page, itemId) => {
    this.setState({
      current: page,
      shortcutItemId: itemId
    })
  }

  navToSection = section => {
    this.setState({
      current: section
    })
  }

  clearHighlight = () => {
    this.setState({
      scheduleApplicationId: 0,
      scheduleApplicationType: '',
      shortcutItemId: null
    })
  }

  handleClick = e => {
    this.setState({
      current: e.key,
      detailShowing: false
    })
    if (this.state.screenWidth < 700) {
      document.getElementById('taskHeader').scrollIntoView(true)
      document.getElementById('taskHeader').scrollTop += 12
    }
  }

  toggleDetails() {
    this.setState({
      detailShowing: !this.state.detailShowing
    })
  }

  handleJobStatusChange = value => {
    this.setState({
      jobStatusValue: value
    })
  }

  handleEditJobClick() {
    this.setState({
      isEditing: !this.state.isEditing
    })
  }
  render() {
    return (
      <div>
        <BackTop />
        <div className="dataHeader">
          <JobTitle
            handleJobStatusChange={this.handleJobStatusChange}
            isEditing={this.state.isEditing}
            maintenenceJob={this.props.match.params.jobType === 'Maintenance-Service'}
          />
          <div>
            {this.props.match.params.jobType === 'Maintenance-Service' && (
              <RepairJobMenu
                currentKey={this.state.current}
                screenWidth={this.state.screenWidth}
                handleClick={this.handleClick}
                match={this.props.match}
              />
            )}
            {this.props.match.params.jobType !== 'Maintenance-Service' && (
              <InstallJobMenu
                currentKey={this.state.current}
                screenWidth={this.state.screenWidth}
                handleClick={this.handleClick}
                match={this.props.match}
              />
            )}
          </div>
        </div>
        <div className="dataPanel">
          <div className="wrapPanel">
            <div className={this.state.detailShowing ? 'jobGroup' : 'jobGroup hiddenStyle'}>
              <JobDetails
                handleEditJobClick={() => this.handleEditJobClick()}
                handleSaveJob={this.handleSaveJob}
                isEditing={this.state.isEditing}
                jobStatus={this.state.jobStatusValue}
                jobId={this.props.match.params.jobId}
                userId={this.props.authentication.user.userId}
              />
            </div>
            <div
              className={
                this.state.detailShowing ? 'toggleVisibilityBar' : 'toggleVisibilityBar rotateDiv'
              }
              onClick={() => this.toggleDetails()}
              id="taskHeader"
            />
            <JobFunctions
              user={this.props.authentication.user}
              currentTask={this.state.current}
              jobId={this.props.match.params.jobId}
              navTo={this.navTo}
              navToSection={this.navToSection}
              scheduleApplicationId={this.state.scheduleApplicationId}
              scheduleApplicationType={this.state.scheduleApplicationType}
              clearHighlight={this.clearHighlight}
              handleShortcut={this.handleShortcut}
              shortcutItemId={this.state.shortcutItemId}
            />
            &copy; G-Tech Elevator Associates LLC
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ authentication }, ownProps) => ({
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators({}),
  dispatch
})

JobView.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobView))



// WEBPACK FOOTER //
// ./src/containers/job/jobView.js